import Rellax from 'rellax'
import mql from '../modules/_mediaQueryList'
import MvSlider from '../modules/_MvSlider'
import './common'
import './service/index'
import './recruit/index'
import './contact/index'

const frontPage = document.getElementById('front-page')

// parallax
{
  if (frontPage) {
    new Rellax('[data-rellax-speed]', {
      center: true,
      breakpoints: [768, 768, 768]
    })
  }
}

// 背景色変更
{
  if (frontPage) {
    const page = document.getElementById('js-page')
    const mainvisual = document.getElementById('js-mainvisual')

    const activeClass = 'is-white'

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        page.classList.remove(activeClass)
      } else {
        page.classList.add(activeClass)
      }
    }, {
      rootMargin: "-50% 0%"
    })
    observer.observe(mainvisual)
  }
}

// mainvisual
{
  if (frontPage) {
    const mainvisual = document.getElementById('js-mainvisual')
    const sliders = [...document.querySelectorAll('.js-mv-slider')]
    sliders.forEach(sliderEl => {
      const slider = new MvSlider(sliderEl)
      slider.init()
      slider.play()
    })

    setTimeout(() => {
      mainvisual.classList.add('is-active')
    }, 100);

    const footprints = [...mainvisual.querySelectorAll('.js-footprint-walk')]
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-active')
        }
      })
    }, {
      rootMargin: "-50% 0% -50%"
    })
    footprints.forEach(target => {
      observer.observe(target)
    })

    const randomFootprints = [...mainvisual.querySelectorAll('.js-footprint-random')]
    randomFootprints.forEach((target, index) => {
      setInterval(() => {
        target.style.left = Math.floor(Math.random() * 800) / 10 + 10 + '%'
        target.style.top = Math.floor(Math.random() * 500) / 10 + '%'
        target.style.transform = `rotate(${Math.floor(Math.random() * 360)}deg)`
        target.classList.add('is-active')

        setTimeout(() => {
          target.classList.remove('is-active')
        }, 2000);
      }, 4000 + index * 400);
    })
  }
}

// service
{
  if (frontPage) {
    const target = document.getElementById('js-service-deco')
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        target.classList.add('is-active')
      }
    }, {
      rootMargin: "-50% 0% -50%"
    })
    observer.observe(target)
  }
}

// recruit
{
  if (frontPage) {
    const target = document.getElementById('js-recruit')
    const trigger = document.getElementById('js-recruit-button')

    trigger.addEventListener('mouseenter', () => {
      target.classList.add('is-hover')
    })

    trigger.addEventListener('mouseleave', () => {
      target.classList.remove('is-hover')
    })

    const heading = document.getElementById('js-recruit-heading')
    const onScroll = () => {
      if (!mql.matches) {
        heading.style.transform = ''
        return
      }

      const baseHeight = window.innerHeight
      const top = target.getBoundingClientRect().top
      const ratio = top / baseHeight - 0.3
      const num = (ratio * 200 - 100) * 0.4 + 30

      heading.style.transform = `translateX(${ num }%)`
    }

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        window.addEventListener('scroll', onScroll)
      } else {
        window.removeEventListener('scroll', onScroll)
      }
    })
    observer.observe(target)
  }
}

// popup
{
  if (frontPage) {
    const triggers = [...document.querySelectorAll('.js-popup-close')]

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true'
        const parent = trigger.parentElement

        trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')
        trigger.setAttribute('aria-label', isExpanded ? '開く' : '閉じる')
        parent.setAttribute('aria-hidden', isExpanded ? 'true' : 'false')
      })
    })
  }
}

// about
{
  if (frontPage) {
    const target = document.getElementById('js-about')
    const bg = document.getElementById('js-about-bg')

    const onScroll = () => {
      const baseHeight = window.innerHeight - (window.innerHeight / 3)
      const top = target.getBoundingClientRect().top - 100
      const ratio = top / baseHeight

      if (ratio <= 0) {
        bg.style.borderRadius = 0
        return
      }

      if (ratio >= 1) {
        bg.style.borderRadius = ''
        return
      }

      const radius = 50 * ratio

      bg.style.borderRadius = `${radius}vw ${radius}vw 0 0`
    }

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        window.addEventListener('scroll', onScroll)
      } else {
        window.removeEventListener('scroll', onScroll)
      }
    })
    observer.observe(target)
  }
}
